











// Copyright © 2021 Move Closer

import { defineComponent, SetupContext } from '@vue/composition-api'

import { DashmixAccordionProps } from './Accordion.contracts'
import { DashmixAccordionItem } from './_partials'
import { dashmixAccordionProps, useDashmixAccordion } from './Accordion.hooks'

/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const DashmixAccordion = defineComponent({
  name: 'DashmixAccordion',
  components: { DashmixAccordionItem },
  props: dashmixAccordionProps,
  emits: ['toggled'],

  setup (props: DashmixAccordionProps, ctx: SetupContext) {
    return useDashmixAccordion(props, ctx)
  }
})

export default DashmixAccordion
